module.exports = __webpack_public_path__ + "static/undraw_setup_wizard_r6mr-29db19675e7a44c239cc5ac5b0edc129.svg";